<template>
  <DatatableReportV3
    ref="calls_datatable"
    title="Incoming Calls"
    :map-records="requestAggregates"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CallNoteLabel from "@/components/CallNoteLabel.vue";
import SecondsLabel from "@/components/SecondsLabel.vue";
import CallModalLink from "@/CallComponents/CallModalLink.vue";
import CallNoteLink from "@/CallComponents/CallNoteLink.vue";
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[3, "desc"]],
        columns: [
          {
            data: "call_id",
            title: "Call ID",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.calls,
            responsivePriority: 3
          },
          {
            data: "call_status",
            title: "Status",
            orderData: 2,
            responsivePriority: 5
          },
          {
            data: "call_status_alpha",
            visible: false,
            searchable: false,
            responsivePriority: 14
          },
          {
            data: "start_time",
            title: "Start Time",
            filterName: "start_date",
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "answered",
            title: "Answered",
            responsivePriority: 7
          },
          {
            data: "duration",
            title: "Duration",
            className: "text-right",
            searchable: false,
            responsivePriority: 8
          },
          {
            data: "ended_at",
            title: "End Time",
            searchable: false,
            filterName: "ended_at",
            responsivePriority: 12
          },
          {
            data: "claimed_by",
            title: "Assigned To",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.assignees,
            filterName: "assigned_to",
            responsivePriority: 6
          },
          { data: "caller_id", title: "Caller ID", responsivePriority: 1 },
          {
            data: "phone",
            title: "Phone #",
            responsivePriority: 2
          },
          {
            data: "call_source",
            title: "Call Source",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.sources,
            responsivePriority: 9
          },
          {
            data: "linked",
            title: "Linked",
            className: "text-right",
            searchable: false,
            filterClassName: "linked-filter-width",
            responsivePriority: 11
          },
          {
            data: "call_revenue_cents",
            title: "Call Revenue",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total,
            searchable: false,
            responsivePriority: 10
          },
          {
            data: "call_note",
            title: "Note",
            orderable: false,
            searchable: false,
            responsivePriority: 13
          }
        ],
        vueComponents: [
          {
            rootId: "seconds-label-vue",
            component: SecondsLabel
          },
          {
            rootId: "call-modal-link-vue",
            component: CallModalLink,
            options: {
              store
            }
          },
          {
            rootId: "call-notes-modal-vue",
            component: CallNoteLink,
            options: {
              store
            }
          },
          {
            rootId: "call-note-tooltip",
            component: CallNoteLabel
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Incoming Calls" });
  },
  methods: {
    requestAggregates(ajaxRequest) {
      ajaxRequest.include_aggregates = true;
      return ajaxRequest;
    }
  }
};
</script>

<style lang="scss">
.call-note-cell {
  display: flex;
  align-items: center;
}
</style>

<style lang="scss" scoped>
:deep(.linked-filter-width) {
  min-width: 130px;
}
</style>
